import { useWatch, useFormContext } from "react-hook-form";
import { GridLogicOperator } from "@mui/x-data-grid";
import type { GridFilterModel } from "@mui/x-data-grid-premium";
import { getAccessedPropertyNames } from "src/components/Form/utils/getAccessedPropertyNames.ts";

export const useServerSelectFilter = (
  serverOptions: {
    filter?:
      | GridFilterModel["items"]
      | { (values: any, modal: boolean): GridFilterModel["items"] };
    logicOperator?: GridFilterModel["logicOperator"];
  },
  modal: boolean,
) => {
  const { getValues } = useFormContext();
  useWatch({
    // @ts-ignore
    name: getFilterWatchNames(
      {
        filter: serverOptions?.filter,
        values: getValues(),
      },
      modal,
    ),
    disabled: !!serverOptions?.filter,
  });

  if (serverOptions?.filter || serverOptions.logicOperator) {
    return {
      logicOperator: serverOptions?.logicOperator
        ? serverOptions.logicOperator
        : GridLogicOperator.And,
      items:
        typeof serverOptions.filter === "function"
          ? serverOptions.filter(getValues(), modal)
          : serverOptions.filter || [],
    };
  }
  return undefined;
};

const getFilterWatchNames = (
  {
    values,
    filter,
  }: {
    values: any;
    filter?:
      | GridFilterModel["items"]
      | { (values: any, modal: boolean): GridFilterModel["items"] };
  },
  modal: boolean,
) => {
  if (!filter) {
    return undefined;
  }
  if (typeof filter !== "function") {
    return undefined;
  }

  return getAccessedPropertyNames({
    object: values,
    callback: (values) => filter(values, modal),
  });
};
